module.exports = __webpack_public_path__ + "static/img/reChangJing1.764ad2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/reChangJing1.png
// module id = gs87
// module chunks = 2